import React from 'react';
import * as styles from './index.module.less';

interface IProps {
  type: 'beta' | 'feature' | 'addOn';
  className?: string;
}

const TEXT_MAP = {
  beta: 'Beta',
  feature: 'New',
  addOn: 'Add on',
};

const RightTag = ({ type, className = '' }: IProps) => {
  return (
    <div className={`${styles.tag} ${styles[type]} ${className}`}>
      <span className={styles.tag_text}>{TEXT_MAP[type]}</span>
    </div>
  );
};

export default RightTag;
